import React from 'react';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useNavigate } from 'react-router-dom';
import { ListItem } from './styles';
import { useSelector } from 'react-redux';
import useResponsive from 'src/components/hooks/useResponsive';
import { getUserFromToken } from 'src/DecodeToken';

function Item({ item, pathname, isPermanentOpen, handleDrawerClose }) {
  const doctId = getUserFromToken();
  const { isMobile, isTablet, isDesktop } = useResponsive();
  const navigate = useNavigate();
  const clinic = useSelector((state) => state.app.clinics);
  console.log("clinics.doctid", clinic.doctorId)

  // const className = pathname === item.link ? 'active AppMenuItem' : 'AppMenuItem';
  const isActive = pathname === `/${clinic.clinicId}/${clinic.doctorId}${item.link}`;
  const className = isActive ? 'active AppMenuItem' : 'AppMenuItem';



  const handleClick = () => {
    navigate(`/${clinic.clinicId}/${clinic.doctorId}${item.link}`);

    if ((isMobile || isTablet) && handleDrawerClose) {
      handleDrawerClose();
    }
  };
  return (
    <ListItem className={className} onClick={handleClick} isPermanentOpen={isPermanentOpen} sx={{ width: '279px' }}>
      <ListItemIcon
        sx={{
          width: isMobile || isTablet ? '20px' : '24px',
          height: isMobile || isTablet ? '20px' : '24px',
        }}>
        {item.icon}</ListItemIcon>



      {isPermanentOpen && <ListItemText primary={item.title} />}
    </ListItem>
  );
}
export default Item;